import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";import styled from '@emotion/styled'
import {
  Add,
  Archive,
  ArrowBack,
  ArrowForward,
  Close,
  Code,
  FormatBold,
  FormatItalic,
  FormatQuote,
  FormatStrikethrough,
  FormatUnderlined,
  Keyboard,
  Label as LabelIcon,
  Link,
  MoreVert,
  OpenInNew,
  PersonPin,
  RemoveCircle,
  Reply,
  Search,
  SentimentSatisfied,
  TaskAlt,
  Tune,
  UnfoldMore,
  WebAsset,
  Widgets
} from '@mui/icons-material'
import {forwardRef,} from 'react'

const LabelBlock = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center'
})

const Label = styled('div')(({iconAfter}) => ({
  color: 'inherit',
  fontSize: 'inherit',
  lineHeight: 'inherit',
  margin: iconAfter ? `0 8px 0 0` : `0 0 0 8px`,
  whiteSpace: 'nowrap'
}))

const StyledIcon = styled('div')


(({iconAfter, iconLarge}) => ({
  color: 'inherit',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  order: iconAfter ? 2 : undefined,
  svg: {
    fontSize: iconLarge ? 24 : 18
  }
}))












const IconLabel = forwardRef((props, ref) => {
  const {icon, label, onClick, onMouseEnter, onMouseLeave, iconAfter, iconLarge} = props
  return (
    _jsxs(LabelBlock, { ref: ref, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, children: [
      _jsx(StyledIcon, { iconAfter: iconAfter, iconLarge: iconLarge, children: 
        
          {
            format_bold: _jsx(FormatBold, {} ),
            format_italic: _jsx(FormatItalic, {} ),
            format_underline: _jsx(FormatUnderlined, {} ),
            format_strikethrough: _jsx(FormatStrikethrough, {} ),
            link: _jsx(Link, {} ),
            label: _jsx(LabelIcon, {} ),
            sentiment_satisfied: _jsx(SentimentSatisfied, {} ),
            person_pin: _jsx(PersonPin, {} ),
            code: _jsx(Code, {} ),
            web_asset: _jsx(WebAsset, {} ),
            format_quote: _jsx(FormatQuote, {} ),
            remove_circle: _jsx(RemoveCircle, {} ),
            more_vert: _jsx(MoreVert, {} ),
            open_in_new: _jsx(OpenInNew, {} ),
            unfold_more: _jsx(UnfoldMore, {} ),
            arrow_back: _jsx(ArrowBack, {} ),
            add: _jsx(Add, {} ),
            keyboard: _jsx(Keyboard, {} ),
            search: _jsx(Search, {} ),
            reply: _jsx(Reply, {} ),
            arrow_forward: _jsx(ArrowForward, {} ),
            archive: _jsx(Archive, {} ),
            close: _jsx(Close, {} ),
            tune: _jsx(Tune, {} ),
            task_alt: _jsx(TaskAlt, {} ),
            widgets: _jsx(Widgets, {} )
          }[icon]
        
      })
      , label && _jsx(Label, { iconAfter: iconAfter, children: label})
    ]})
  )
})

export default IconLabel
